<app-dialog
  [(isOpen)]="isOpen"
  (close)="handleClose.emit()"
  data-test-id="tenant-dialog"
>
  <div class="dialog-content" data-test-id="tenant-dialog-content">
    <app-tenant-general-form
      (formSubmit)="onSave()"
      [(name)]="name"
      [(description)]="description"
      [(slugs)]="slugs"
      [(emails)]="emails"
      [(provisioningType)]="provisioningType"
      data-test-id="tenant-dialog-form"
    ></app-tenant-general-form>
  </div>
  <div class="tenant-dialog-footer" data-test-id="tenant-dialog-footer">
    <app-button
      type="secondary"
      (click)="handleClose.emit()"
      data-test-id="tenant-dialog-cancel-button"
      >{{ 'tenantConfiguration.contracts.cancel' | translate }}</app-button
    >
    <app-button
      type="primary"
      (click)="onSave()"
      [disabled]="!isFormValid()"
      data-test-id="tenant-dialog-save-button"
      >{{ 'tenantConfiguration.contracts.save' | translate }}</app-button
    >
  </div>
</app-dialog>
